import axios from 'axios';
import handleApiResponse from './utils';

const getTemplateThumbnail = async ({ __config, id }) => {
	let response = await axios.get(
		`${__config.data_sources.fhir}/Organization/template/${id}/thumbnail?_dc=${new Date().getTime()}`,
		{
			responseType: 'blob',
		}
	);

	response = handleApiResponse(response, false);
	return response?.data;
};

export default getTemplateThumbnail;
